/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react';

import { useAtom } from 'jotai';
import { useRouter } from 'next/router';

import {
  SendOtp,
  SignupService,
  VerifyOtpService,
} from '@/api/fetch/auth-service';
import { getUserbyphone } from '@/api/fetch/marketplace-api';
import {
  SendOtpRequest,
  SignupRequest,
  VerifyOtpRequestGRPC,
} from '@/api/gen-protos/auth_pb';
import { UserByPhoneNumberRequest } from '@/api/gen-protos/users_pb';
import { AuthErrorsAtom, pageLoading, PageLoadingAction } from '@/lib/store';

const useSignUpHook = () => {
  const router = useRouter();

  // const [loading, setloading] = useState(false);
  const [identifiant, setIdentifiant] = useState('');
  const [phone, setPhone] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setnewPassword] = useState('');
  const [newRePassword, setnewRePassword] = useState('');
  const [error, setError] = useAtom(AuthErrorsAtom);

  const [, setIsLoading] = useAtom(pageLoading);

  const udpdateError = (errorKey: string, message: string) => {
    setError({
      ...error,
      [errorKey]: message,
    });
  };

  const resetError = () => {
    setError({});
  };

  const sendOtpSms = async () => {
    setIsLoading(PageLoadingAction.Start);

    if (phone) {
      resetError();

      const sendOtpRequest = new SendOtpRequest();
      sendOtpRequest.setPhonenumber(`+216${phone}`);
      await SendOtp(sendOtpRequest).then((res) => {
        if (res.getMessage() === 'Otp Send Successfully') {
          router.push({
            query: {
              ...router.query,
              screen: 'sms',
            },
          });
        }
      });
    }

    setIsLoading(PageLoadingAction.Stop);
  };

  const verifyUserByPhone = () => {
    if (!phone || phone.length !== 8) {
      udpdateError('new-user', 'Le numéro de téléphone est invalide');

      return;
    }
    setIsLoading(PageLoadingAction.Start);

    resetError();

    const str = `+216${phone}`;

    const userBynationalNumberRequest = new UserByPhoneNumberRequest();
    userBynationalNumberRequest.setPhonenumber(str);

    getUserbyphone(userBynationalNumberRequest)
      .then((UserResponse) => {
        if (UserResponse)
          udpdateError(
            'new-user',
            'Ce numéro est déjà utilisé par un autre utilisateur'
          );
        setIsLoading(PageLoadingAction.Stop);
      })
      .catch((error1) => {
        if (error1 === 'mongo: no documents in result') {
          sendOtpSms();
        }
        setIsLoading(PageLoadingAction.Stop);
      });
  };

  const VerifyOtpSms = async () => {
    setIsLoading(PageLoadingAction.Start);

    resetError();
    if (verificationCode.length === 6 && phone) {
      udpdateError('sms', '');

      const verifyRequest = new VerifyOtpRequestGRPC();
      verifyRequest.setPhonenumber(`+216${phone}`);
      verifyRequest.setOtp(verificationCode.toString());
      await VerifyOtpService(verifyRequest).then(
        (r) => {
          if (r.getMessage() === 'WRONG OTP') {
            udpdateError('sms', 'code de vérification invalide');
            return;
          }
          router.push({
            query: {
              ...router.query,
              screen: 'new-password',
            },
          });
        },
        (_) => {
          udpdateError('sms', 'code de vérification invalide');
        }
      );
    } else {
      udpdateError('sms', 'code verification must contains 6 number');
    }

    setIsLoading(PageLoadingAction.Stop);
  };

  const signupNewUser = () => {
    if (!newPassword || !newRePassword || newPassword !== newRePassword) {
      udpdateError('new-password', 'Vérifier les mots de passe');
      return;
    }
    const { redirect } = router.query;

    setIsLoading(PageLoadingAction.Start);
    const signupRequest = new SignupRequest();
    signupRequest.setUsername(phone);
    signupRequest.setPhonenumber(`+216${phone}`);
    signupRequest.setFullname(identifiant);
    signupRequest.setUsertype(0);
    signupRequest.setEmail('');
    signupRequest.setPassword(newPassword);
    signupRequest.setRoleList(['default-roles-caravel']);
    signupRequest.setEnabled(true);
    SignupService(signupRequest)
      .then(async () => {
        resetError();
        if (redirect && redirect !== '') {
          await router.replace({
            pathname: '/login',
            query: { redirect },
          });
        } else {
          await router.replace({
            pathname: '/login',
          });
        }
        // @ts-ignore
        if (window.rudderanalytics?.track) {
          window.rudderanalytics.track('Signup Successful');
        }
        setIsLoading(PageLoadingAction.Stop);
      })
      .catch(() => {
        udpdateError(
          'new-password',
          'Oops! problème de connexion, veuillez réessayer plus tard '
        );
        setIsLoading(PageLoadingAction.Stop);
      });
  };

  return {
    identifiant,
    setIdentifiant,

    verificationCode,
    setVerificationCode,
    error,
    setError,
    sendOtpSms,
    VerifyOtpSms,
    verifyUserByPhone,
    newPassword,
    setnewPassword,
    newRePassword,
    setnewRePassword,
    signupNewUser,
    phone,
    setPhone,
  };
};

export default useSignUpHook;
